"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataHooks = {
    hiddenRadio: 'hidden-radio',
    label: 'label',
    icon: 'icon',
};
//# sourceMappingURL=constants.js.map